// extracted by mini-css-extract-plugin
export default {"roundedButton":"style_roundedButton__CSIBx","circle":"style_circle__eHjF7"};